import { failureAction, requestAction, successAction } from './actions';
import { fetchRealtyValuation } from './fetchRealtyValuation';

import { TThunkAction } from '../../types/redux/thunk';
import { developerValuationFiltersState } from '../../selectors/developerValuation';
import { getDeveloperId } from '../../selectors';
import { prepareDeveloperValuationState } from '../../mappers/realtyValuation';

export const updateRealtyValuationAction = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const state = getState();
  const developerId = getDeveloperId(state);
  const pricesFilters = developerValuationFiltersState(state);

  dispatch(requestAction());

  const res = await fetchRealtyValuation({
    context,
    developerId,
    newbuildingClass: pricesFilters.buildingClass,
    period: pricesFilters.period,
    regionId: pricesFilters.regionId,
    roomCount: pricesFilters.roomCount,
  });

  if (res instanceof Error) {
    dispatch(failureAction());
  } else {
    const data = prepareDeveloperValuationState(res);

    dispatch(successAction(data));
  }
};
